<template lang="pug">
  .profile-page.page
    .container
      .profile-page__container
        .profile-page__side
          side-nav(
            v-bind:sideNavData="sideNavData"
          )
        router-view
    .page__footer
      main-footer
</template>
<script>

import SideNav from "@/components/sideNav/SideNav";
import MainFooter from "@/components/footer/Footer";

export default {
  name: "AdminPage",
  components: {
    SideNav,
    MainFooter
  },
  data() {
    return {

      sideNavData: {
        links: [
          /*{
            path: "/zzz",
            text: "Центры распределения путевок"
          },*/
          {
            path: "/pages/admin/accounts",
            text: "Учетные записи"
          },
          {
            path: "/pages/admin/camps",
            text: "Лагеря"
          }
          /*{
            path: "/zzz",
            text: "Организации"
          },*/

        ]
      }
    };
  }

};
</script>
